import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MaterialModule } from '@widgets/ui-common/material/material.module';
import { BatchExtraAttachmentsComponent } from './batch-extra-attachments.component';
import { FilePreviewModule } from '@widgets/site-common/file-preview/file-preview.module';

@NgModule({
  imports: [CommonModule, MaterialModule, FilePreviewModule],
  declarations: [BatchExtraAttachmentsComponent],
  exports: [BatchExtraAttachmentsComponent]
})
export class BatchExtraAttachmentsModule {}
